import { render, staticRenderFns } from "./YogaCardAlter.vue?vue&type=template&id=ca4173f0&scoped=true&"
import script from "./YogaCardAlter.vue?vue&type=script&lang=js&"
export * from "./YogaCardAlter.vue?vue&type=script&lang=js&"
import style0 from "./YogaCardAlter.vue?vue&type=style&index=0&id=ca4173f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4173f0",
  null
  
)

export default component.exports